import React from "react";

import { Grid } from "@mui/material";
import { ProgressBarPreview } from "@src/domains/WidgetLibrary/ProgressBar/ProgressBarPreview";
import { useSelector } from "@src/store";
import {
  getLibraryOfferProgressBars,
  getLibraryShippingProgressBars,
} from "@src/store/slices/widgets/selectors";
import { GlobalStylesProgressBarVariantList } from "@src/types/widgetVariants";

import { ShippingProgressBarFullPageDialog } from "./ShippingProgressBarFullPageDialog";

export const ShippingProgressBarOverview = () => {
  const widgets = useSelector(getLibraryShippingProgressBars).filter(
    (widget) => {
      const variant = widget.config.desktop?.variant;
      // sitewide widgets must have backward compatibility for now
      if (widget.enabledSitewide) {
        return true;
      }
      return (
        // @ts-ignore - GlobalStylesProgressBarVariantList is the now supported variants
        variant && GlobalStylesProgressBarVariantList.includes(variant)
      );
    }
  );

  return (
    <Grid
      container
      direction={"column"}
      alignItems={"flex-end"}
      rowSpacing={2}
      columnSpacing={2}
    >
      <Grid
        item
        container
        direction={"row"}
        rowSpacing={4}
        columnSpacing={4}
        sx={{
          display: "grid",
          gridTemplateColumns: "repeat(2, 1fr)",
          gridAutoRows: "1fr",
        }}
      >
        {widgets.map((widget) => (
          <Grid item container key={widget.id}>
            <ProgressBarPreview widget={widget} mode={"toggle"} />
          </Grid>
        ))}
      </Grid>
      <ShippingProgressBarFullPageDialog />
    </Grid>
  );
};
